import React, {Component} from 'react';

export default class CookieConsent extends Component {

    componentDidMount() {

        require('cookieconsent');
        require('cookieconsent/build/cookieconsent.min.css');

        cookieconsent.initialise({
            palette: {
                popup: {
                    background: "#000"
                },
                button: {
                    background: "#50d691",
                    text: "#ffffff"
                }
            },
            content: {
                message: "Fristberegneren.no bruker informasjonskapsler for å samle statistikk og forbedre brukervennligheten av nettstedet. Ved å klikke på siden godtar du bruk av informasjonskapsler. Les mer om bruk av informasjonskapsler på Fristberegneren.no.",
                dismiss: "Ok",
                link: "Les mer om bruk av informasjonskapsler på Fristberegneren.no.",
                href: "cookies"
            }
        });
    }

    render() {
        return null
    }
}


// WEBPACK FOOTER //
// ./src/components/CookieConsent.js